import {Grid, MenuItem, Select, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {Box} from '@mui/system';
import AutoField from '../../components/AutoForm/AutoFieldNew';
import {
  childTitleField,
  childForenamesField,
  childSurnameField,
  childDOBField,
  childNIField,
  childAddressField,
  childPostcodeField,
} from './ReportPackFields';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';
import {UPDATES} from '../../shared/UPDATES';
import {ReportPackFormFragment} from '../../schema-types/ReportPackFormFragment';
import {getReportPackMissingFieldError} from './getReportPackMissingFieldError';
import {useFastAccountContacts} from '../../components/ContactActions/useFastAccountContacts';
import {themeColors} from '../../theme/Theme';
import {sortAlphabeticallyByName} from '../../features/bulkAdmin/useBulkAdmin';

export const DependantForm = ({disabled}: {disabled?: boolean}) => {
  const {values, setValues} = useAutoForm<ReportPackFormFragment>();
  const [selectedDependant, setSelectedDependant] = useState<string | null>(null);
  const {contacts} = useFastAccountContacts();

  useEffect(() => {
    if (values.childAddress?.includes('\n')) {
      setValues(UPDATES._2202, (previous) => {
        return {
          ...previous,
          childAddress: previous.childAddress?.replace(/\n/g, ' ') ?? null,
        };
      });
    }
  }, [values.childAddress]);

  return (
    <>
      <Typography>Child details:</Typography>
      <Grid container p={2} mb={2} spacing={2} direction="column">
        <Grid item>
          <Box display="flex" flexDirection="column">
            <Select
              sx={{
                minWidth: '300px',
              }}
              onChange={(e: any) => {
                const dependantId = e.target.value;
                const dependant = contacts.find((x) => x.id === dependantId);
                setSelectedDependant(dependantId);
                setValues(UPDATES._2203, (previous) => {
                  return {
                    ...previous,
                    childTitle: dependant?.title ?? null,
                    childForenames: dependant?.firstName ?? null,
                    childSurname: dependant?.lastName ?? null,
                    childDob: dependant?.dob ?? null,
                    childNiNumber: dependant?.nationalInsurance ?? null,
                    childAddress: dependant?.fullAddress ?? null,
                    childPostcode:
                      dependant?.addresses?.find((x) =>
                        dependant?.fullAddress?.includes(x.postcode ?? '')
                      )?.postcode ?? null,
                  };
                });
              }}
              value={selectedDependant}
            >
              {contacts
                ?.filter((x) => x.contactStatus === 'Dependant')
                .sort(sortAlphabeticallyByName)
                .map((x) => {
                  return (
                    <MenuItem key={x!.id} value={x?.id}>
                      {x?.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </Box>
        </Grid>
        {selectedDependant || values.childTitle ? (
          <>
            <Grid item>
              <AutoField
                readOnly={disabled}
                error={getReportPackMissingFieldError(values, childTitleField.id)}
                field={childTitleField}
              />
            </Grid>
            <Grid item>
              <AutoField
                readOnly={disabled}
                error={getReportPackMissingFieldError(values, childForenamesField.id)}
                field={childForenamesField}
              />
            </Grid>
            <Grid item>
              <AutoField
                readOnly={disabled}
                error={getReportPackMissingFieldError(values, childSurnameField.id)}
                field={childSurnameField}
              />
            </Grid>
            <Grid item>
              <AutoField
                readOnly={disabled}
                error={getReportPackMissingFieldError(values, childDOBField.id)}
                field={childDOBField}
              />
            </Grid>
            <Grid item>
              <AutoField
                readOnly={disabled}
                error={getReportPackMissingFieldError(values, childNIField.id)}
                field={childNIField}
              />
            </Grid>
            <Grid item>
              <AutoField
                readOnly={disabled}
                error={getReportPackMissingFieldError(values, childAddressField.id)}
                field={childAddressField}
              />
            </Grid>
            <Grid item>
              <AutoField
                readOnly={disabled}
                error={getReportPackMissingFieldError(values, childPostcodeField.id)}
                field={childPostcodeField}
              />
            </Grid>
          </>
        ) : (
          <Typography variant="caption" color={themeColors.coral}>
            A dependant must be selected before proceeding
          </Typography>
        )}
      </Grid>
    </>
  );
};
